import React, { useState } from 'react';
import { FaqItem } from './FaqItem';
import { faqs } from '../../data/productContent';
import { siteConfig } from '../../data/siteConfig';
export function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);
  return <section id="faqs" aria-labelledby="faqs-title" className="scroll-mt-16 border-t border-line" data-id="element-171" data-mp="2a3r54sn8aa1n">
      <div className="mx-auto grid max-w-page gap-12 px-5 py-20 md:px-10 lg:grid-cols-[1fr_1.8fr] lg:gap-20 lg:py-28" data-id="element-172" data-mp="1v6gnf1jzs7xh">
        <div data-id="element-173" data-mp="206311c3qfq6t">
          <h2 id="faqs-title" className="font-display text-4xl font-medium leading-tight text-ink md:text-[52px]" data-id="element-174" data-mp="206mh0n9to4i7">
            Questions, answered.
          </h2>
          <p className="mt-4 max-w-sm text-[17px] leading-relaxed text-ink-muted" data-id="element-175" data-mp="1r4vflumbeju5">
            Something else on your mind? Call{' '}
            <a href={siteConfig.support.phoneHref} className="font-medium text-ink underline underline-offset-4" data-id="element-176" data-mp="3gkurvkl8cpe0">
              {siteConfig.support.phone}
            </a>
            .
          </p>
        </div>
        <div className="border-t border-ink" data-id="element-177" data-mp="2nemnc5utei0u">
          {faqs.map(faq => <FaqItem key={faq.id} faq={faq} open={openId === faq.id} onToggle={() => setOpenId(id => id === faq.id ? null : faq.id)} data-id="element-178" data-mp="2jf5gb7zqpctk" />)}
        </div>
      </div>
    </section>;
}